import type { FilterDefinition } from '@/components/filters/list-filter-types'
import type { ListBrowseLeadingScopeProps } from '@/components/filters/list-browse-toolbar'

type BuildLeadingScopePropsArgs<TFilters, TCtx> = {
  leadDef: FilterDefinition<TFilters, TCtx> | undefined
  filters: TFilters
  ctx: TCtx
  onFiltersChange: (next: TFilters) => void
  open: boolean
  onOpenChange: (open: boolean) => void
  onClose: () => void
  disabled?: boolean
  density?: ListBrowseLeadingScopeProps['density']
}

export function buildLeadingScopeProps<TFilters, TCtx>({
  leadDef,
  filters,
  ctx,
  onFiltersChange,
  open,
  onOpenChange,
  onClose,
  disabled,
  density = 'toolbar',
}: BuildLeadingScopePropsArgs<TFilters, TCtx>): ListBrowseLeadingScopeProps | undefined {
  if (!leadDef?.renderPopover) return undefined

  return {
    label: leadDef.label,
    displayValue: leadDef.displayValue(filters, ctx),
    open,
    onOpenChange,
    disabled,
    density,
    popoverContent: open
      ? leadDef.renderPopover({
          filters,
          ctx,
          onChange: (next) => {
            onFiltersChange(next)
            onClose()
          },
        }) ?? null
      : null,
  }
}
